const meta = {
  concepts: 'Concepts',
  types: 'Data types',
  authenticating: 'Sign in',
  'common-tasks': 'Guides',
};

export default meta;
